import ServiceHero from "./components/ServiceHero";
import TrustBar from "../../components/feature/TrustBar";
import ServicesDetail from "./components/ServicesDetail";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/TestimonialsSection";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTASection from "../../components/feature/FinalCTASection";
import InquireForm from "./components/InquireForm";
import { servicesFaqs } from "../../mocks/faq";
import MidPageCTA from "../../components/feature/MidPageCTA";

const serviceTrustItems = [
  { number: "3", label: "Core Session Types", icon: "ri-camera-2-line" },
  { number: "15+", label: "Years Experience", icon: "ri-award-line" },
  { number: "100%", label: "Custom Packages", icon: "ri-settings-3-line" },
  { number: "5★", label: "Client Rating", icon: "ri-star-line" },
];

const serviceAIContent = {
  title: "Our Photography Services",
  subtitle: "Complete session guide",
  what: "Precious Keepsakes Photography offers luxury newborn, wedding, and milestone photography services in San Antonio, TX. Every session is a fully custom experience guided by photographer Stephanie with 15+ years of fine art portraiture expertise.",
  services: [
    "Newborn Photography — in-studio and on-location, up to 4 hours",
    "Luxury Wedding Photography — full-day or partial coverage with album",
    "Maternity — intimate editorial sessions at any stage",
    "Senior Portraits — modern, authentic, editorial",
    "Quinceañera & Sweet 16 — elegantly documented milestone events",
    "Family & Milestone Sessions — on-location throughout San Antonio",
  ],
  benefits: [
    "Custom packages tailored to every budget and vision",
    "Heirloom-quality fine art print products",
    "Guided, stress-free sessions — no experience needed",
    "Travel available throughout San Antonio and Texas",
    "Private gallery delivery within 2–6 weeks",
  ],
  process: [
    "Inquiry — complete the form or call 210-815-4698",
    "Consultation — discuss your session vision",
    "Session — relaxed, guided experience",
    "Gallery delivery + product selection",
  ],
};

export default function ServicesPage() {
  return (
    <main>
      <ServiceHero />
      <TrustBar items={serviceTrustItems} />
      <ServicesDetail />
      <MidPageCTA
        headline="Custom Packages Built Around Your Vision"
        subtext="No cookie-cutter pricing. Every keepsake session is tailored to your story, your family, and your investment."
        ctaLabel="Inquire About Your Session"
        ctaHref="/services"
        secondaryLabel="Call Stephanie Directly"
        secondaryHref="/location"
      />
      <AIAnswerBlock {...serviceAIContent} />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreasSection />
      <TestimonialsSection title="Clients Love Their Sessions" />
      <FAQSection faqs={servicesFaqs} title="Session Questions Answered" subtitle="Everything you need to know before your session" />
      <InquireForm />
      <FinalCTASection
        title="Your Story Deserves to Be Told"
        subtitle="Begin with a personal consultation. Stephanie will craft the perfect keepsake session experience for your family."
        ctaLabel="Create Your Custom Keepsake"
        backgroundImage="https://images-pw.pixieset.com/site/BAJyQr/DDl4Qv/004-20241021-ea579869-1500.jpg"
      />
    </main>
  );
}